import { render, staticRenderFns } from "./disputeDetial.vue?vue&type=template&id=3421b958&scoped=true&"
import script from "./disputeDetial.vue?vue&type=script&lang=js&"
export * from "./disputeDetial.vue?vue&type=script&lang=js&"
import style0 from "./disputeDetial.vue?vue&type=style&index=0&id=3421b958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3421b958",
  null
  
)

export default component.exports